import { Typography } from 'antd';
import type { TextProps } from 'antd/lib/typography/Text';
import styled from 'styled-components';
import { type DisplaySelectFieldProps } from '../../context';
import VehicleArrow from '../assets/vehicle-arrow.svg';

const StyledWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 54px;
`;

const Text = (props: TextProps) => <Typography.Text {...props} />;

const StyledText = styled(Text)`
    font-size: 20px;
    font-weight: bold;

    color: var(--ant-primary-color);

    width: calc(100% - 1rem);
    padding-right: 18px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    display: block;
`;

const StyledIcon = styled(VehicleArrow)`
    width: 24px;
    height: 24px;
`;

const DisplaySelectField = ({ value }: DisplaySelectFieldProps) => (
    <StyledWrapper>
        <StyledText>{value}</StyledText>
        <StyledIcon />
    </StyledWrapper>
);

export default DisplaySelectField;
